import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-obs-modal',
  templateUrl: './obs-modal.component.html',
  styleUrls: ['./obs-modal.component.scss']
})
export class ObsModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  observacao = '';
  idCupom = '';
  // 0 - Pedido | 1 - Kit
  tipo = 0;
  titulo = '';

  constructor(public dialogRef: MatDialogRef<ObsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.tipo = this.data.tipo;

    switch (this.tipo) {
      case 0:
        this.titulo = 'Observação do PEDIDO Nº ' + this.idCupom;
        this.idCupom = this.data.idCupom;
        break;

      case 1:
        this.titulo = 'Observação do Kit';
        this.observacao = this.data.observacao;
        break;

      default:
        break;
    }

  }

  salvar() {

    switch (this.tipo) {
      case 0:
        this.dialogRef.close(this.observacao);
        break;

      case 1:
        this.dialogRef.close({ salvar: true, obs: this.observacao });
        break;

      default:
        break;
    }
  }

  fechar() {
    this.dialogRef.close();
  }

}
